<template>
    <div
        v-if="endorsementItems?.length > 0"
        class="uro-endorsements"
    >
        <BaseEndorsement
            v-for="item in endorsementItems"
            :key="item.id"
            :title="item.title"
            :image="item.image"
            :url="item.url"
            class="uro-endorsements__item"
        />
    </div>
</template>

<script setup>
const props = defineProps({
    items: {
        type: Array,
        required: false,
        default: null,
    },
});

const endorsementItems = computed(() => {
    return props.items.map((item) => {
        return {
            title: item.blockTitle,
            image: item.image,
            url: item.externalLink,
        };
    });
});
</script>

<style lang="less" src="./BaseEndorsements.less" />
